export default __webpack_public_path__ + "static/media/blessed-1.961af610.jpg";